module.exports = __webpack_public_path__ + "static/media/Commercial.bb4b84a1.png";


//////////////////
// WEBPACK FOOTER
// ./public/maxsizeimages/books/Commercial.png
// module id = 1728
// module chunks = 1